import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { environment } from '../../environments/environment';
import { AuthService } from '../services/auth.service';

@Component({
    selector: 'app-auth-success',
    template: `
        <div class="loading-container">
            <h2>Authentication successful!</h2>
            <p>Redirecting to application...</p>
        </div>
    `,
    styles: [
        `
            .loading-container {
                display: flex;
                flex-direction: column;
                align-items: center;
                justify-content: center;
                height: 100vh;
            }
        `
    ]
})
export class AuthSuccessComponent implements OnInit {
    constructor(
        private router: Router,
        private route: ActivatedRoute,
        private authService: AuthService
    ) {}

    ngOnInit(): void {
        console.log('AuthSuccessComponent initialized');
        if (this.authService.IS_LOCALHOST) {
            console.log('setting user session in success component');
            this.route.queryParams.subscribe((params) => {
                this.authService.setSession({
                    accessToken: params['access_token'],
                    idToken: params['id_token'],
                    refreshToken: params['refresh_token']
                });
            });
        }

        console.log('Authentication successful, navigating to app');
        this.router.navigate([environment.postLoginPath]);
    }
}
